import { NgModule, ErrorHandler } from '@angular/core';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

import { ExerciseTabs } from '../components/exercise-tabs/exercise-tabs';
import { AppHeader } from '../components/app-header/app-header';
import { FoodTabs } from '../components/food-tabs/food-tabs';
import { InfoFab } from '../components/info-fab/info-fab';
import { DashboardTabs } from '../components/dashboard-tabs/dashboard-tabs';
import { TextareaAutoresize } from '../components/TextareaAutoresize';

import { ExerciseEditPage } from '../pages/exercises/exercise-edit';
import { ExerciseListPage } from '../pages/exercises/exercise-list';
import { ActivityRoutineListPage } from '../pages/exercises/activity-routine-list';

import { DashboardActivityPage } from '../pages/dashboard/activity/dashboard-activity';
import { DashboardExercisePage } from '../pages/dashboard/exercise/dashboard-exercise';
import { DashboardWorkoutPage } from '../pages/dashboard/exercise/dashboard-workout';
import { DashboardWorkoutExercisesPage } from '../pages/dashboard/exercise/dashboard-workout-exercises';
import { DashboardWorkoutSetPage } from '../pages/dashboard/exercise/dashboard-workout-set';
import { DashboardLogFoodPage } from '../pages/dashboard/nutrition/dashboard-log-food';
import { DashboardLogSupplementPage } from '../pages/dashboard/nutrition/dashboard-log-supplement';
import { DashboardNutritionPage } from '../pages/dashboard/nutrition/dashboard-nutrition';
import { DashboardNotesPage } from '../pages/dashboard/dashboard-notes';

import { FoodEditPage } from '../pages/food/food-edit';
import { FoodInventoryPage } from '../pages/food/food-inventory';
import { FoodPlanPage } from '../pages/food/food-plan';
import { FoodPlanEditPage } from '../pages/food/food-plan-edit';
import { MealPage } from '../pages/food/meal';
import { MealEditPage } from '../pages/food/meal-edit';
import { MemoPage } from '../pages/memo/memo';
import { MemoEditPage } from '../pages/memo/memo-edit';
import { SupplementPage } from '../pages/food/supplement';
import { SupplementEditPage } from '../pages/food/supplement-edit';
import { TabsPage } from '../pages/tabs/tabs';

import { 
  ActivityRoutineProvider,
  ApiProvider, 
  ConfigurationProvider, 
  DayEntryProvider,
  EnumProvider, 
  ExerciseProvider,
  FoodProvider, 
  FoodPlanProvider,
  MealProvider,
  SupplementProvider,
  SupplementStackProvider,
  UserMemoProvider,
  UserProvider,
  WorkoutProvider
} from '../providers/providers';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { IonicStorageModule } from '@ionic/storage';

@NgModule({
  declarations: [
    MyApp,
    AppHeader,
    ExerciseTabs,
    FoodTabs,
    InfoFab,
    DashboardTabs,
    TextareaAutoresize,

    ActivityRoutineListPage,
    DashboardActivityPage,
    DashboardExercisePage,
    DashboardLogFoodPage,
    DashboardLogSupplementPage,
    DashboardNotesPage,
    DashboardNutritionPage,
    DashboardWorkoutPage,
    DashboardWorkoutExercisesPage,
    DashboardWorkoutSetPage,
    ExerciseEditPage,
    ExerciseListPage,
    FoodEditPage,
    FoodInventoryPage,
    FoodPlanEditPage,
    FoodPlanPage,
    MealPage,
    MealEditPage,
    MemoEditPage,
    MemoPage,
    SupplementEditPage,
    SupplementPage,
    TabsPage,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    ActivityRoutineListPage,
    DashboardActivityPage,
    DashboardExercisePage,
    DashboardLogFoodPage,
    DashboardLogSupplementPage,
    DashboardNotesPage,
    DashboardNutritionPage,
    DashboardWorkoutPage,
    DashboardWorkoutExercisesPage,
    DashboardWorkoutSetPage,
    ExerciseEditPage,
    ExerciseListPage,
    FoodEditPage,
    FoodInventoryPage,
    FoodPlanEditPage,
    FoodPlanPage,
    MealPage,
    MealEditPage,
    MemoEditPage,
    MemoPage,
    SupplementEditPage,
    SupplementPage,
    TabsPage
  ],
  providers: [
    ActivityRoutineProvider,
    ApiProvider,
    ConfigurationProvider,
    DayEntryProvider,
    EnumProvider,
    ExerciseProvider,
    FoodProvider,
    FoodPlanProvider,
    MealProvider,
    SupplementProvider,
    SupplementStackProvider,
    UserMemoProvider,
    UserProvider,
    WorkoutProvider,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    // native
    SplashScreen,
    StatusBar
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts